(function () {
  const mobileVocSteps = document.querySelector('.vocSteps.mobile');
  const desktopVocSteps = document.querySelector('.vocSteps.desktop');
  const isMobile = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

  if (isMobile) {
    mobileVocSteps.classList.add('active');
  } else {
    desktopVocSteps.classList.add('active');
  }

  const settingsDescriptions = [...document.querySelectorAll('[data-setting-description]')];
  const onClick = ({ currentTarget }) => {
    if (currentTarget.classList.contains('active')) {
      return;
    }

    const {
      dataset: { settingDescription },
      parentElement
    } = currentTarget;

    parentElement.querySelector('[data-setting-description].active').classList.remove('active');
    parentElement.nextElementSibling.querySelector('.active').classList.remove('active');
    parentElement.nextElementSibling.querySelector(`[data-setting-image=${settingDescription}]`).classList.add('active');
    currentTarget.classList.add('active');
  }
 
  settingsDescriptions.map((item) => {
    item.onclick = onClick;
  });

  const states = { true: 'remove', false: 'add' };
  const titles = document.querySelectorAll('.faq .title');

  const handleClick = ({ currentTarget: { parentElement } }) => {
    const isOpen = parentElement.classList.contains('open');
    titles.forEach((title) => title.parentElement.classList.remove('open'));
    parentElement.classList[states[isOpen]]('open');
  };

  titles.forEach((title) => title.onclick = handleClick);
})()